module.exports = "/fonts/vendor/desiigner-svg/svg/fontawesome/light/sun-cloud.svg?8be4ac544e2f822524cb3c514590e52f";